// import Constants from './Constants'
// import NotifyActions from './NotifyActions'
import ItemActions from './ItemActions'

const options = { 
  parentName : 'project', 
  itemsName : 'templates',
  actionTypeBase : 'TEMPLATE', 
  parentIdKey : 'projectId', 
  humanItemName : 'Template',
  notify : {
    create : true,
    add : true,
    remove : true,
    update : true
  }
}

const actions = ItemActions.create( options )

module.exports = Object.assign( actions, {
  // extra
} )
